'use strict';

var luxon = require('luxon');
var index = require('./variants/index.js');

const date = (locale, date, variant = 'dateTime', timezone)=>{
    const dateVariant = {
        ...index.default[variant]
    };
    if (timezone) {
        dateVariant.timeZone = timezone;
    }
    return luxon.DateTime.fromJSDate(new Date(date)).setLocale(locale).toLocaleString(dateVariant);
};
const dateNumeric = (date, variant = 'dateTime', timezone)=>{
    let dt = luxon.DateTime.fromJSDate(new Date(date));
    if (timezone) {
        dt = dt.setZone(timezone);
    }
    // Docs: https://moment.github.io/luxon/#/formatting?id=table-of-tokens
    switch(variant){
        case 'dateTime':
            return dt.toFormat('yyyy-LL-dd HH:mm:ss ZZZZ');
        case 'date':
            return dt.toFormat('yyyy-LL-dd');
        case 'time':
            return dt.toFormat('HH:mm:ss ZZZZ');
    }
};
const relativeTime = (locale, date, baseDate)=>{
    return luxon.DateTime.fromJSDate(new Date(date)).setLocale(locale).toRelative({
        base: baseDate != null ? luxon.DateTime.fromJSDate(new Date(baseDate)).setLocale(locale) : undefined
    });
};
const months = (locale)=>new Array(12).fill(0).map((_, index)=>luxon.DateTime.now().setLocale(locale).set({
            month: index + 1
        }).toFormat('LLLL'));
const days = (locale)=>new Array(7).fill(0).map((_, index)=>({
            long: luxon.DateTime.now().setLocale(locale).set({
                weekday: index
            }).toFormat('cccc'),
            short: luxon.DateTime.now().setLocale(locale).set({
                weekday: index
            }).toFormat('ccc')
        }));

exports.date = date;
exports.dateNumeric = dateNumeric;
exports.days = days;
exports.months = months;
exports.relativeTime = relativeTime;
//# sourceMappingURL=index.js.map
